const $ = require('jquery');
module.exports = function () {

    require('./ferry');

    const InfiniteScroll = require('infinite-scroll');

    const $body = $('body');

    $body.addClass('jsenabled');

    // check if browser is IE - if true, add body class
    const isIE = navigator.appName === 'Microsoft Internet Explorer' ||
        !!(navigator.userAgent.match(/Trident/) ||
            navigator.userAgent.match(/rv:11/)) ||
        (typeof $.browser !== "undefined" && $.browser.msie === 1);

    if (isIE) {
        $body.addClass('browser-ie');
    }


    // push gtm-event data-values on anchors to datalayer
    $body.on('click', '[data-gtm-event]', function () {
        let gtm_event = $(this).data('gtm-event');
        let page_url = $(location).attr('href');

        // console.log({'dbk_category' : 'click_event', 'dbk_event' : gtm_event, 'dbk_url' : page_url }); // development

        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({ 'dbk_category': 'click_event', 'dbk_event': gtm_event, 'dbk_url': page_url }); // production
        }
    });


    // sticky top-bar
    var $topbar = $('header[role="masthead"] .top-bar');
    var $topbarWrap = $topbar.closest('.sticky-wrapper');
    var topbarOffset = $topbar.outerHeight();
    var triggerOffset = $(window).height() * 0.1; // scroll distance before top-bar pops out

    $(document).scroll(function () {
        var topoffset = $(document).scrollTop();

        if (topoffset > topbarOffset) {
            if (!$topbar.hasClass('top-bar-scrolled')) {
                $topbarWrap.css('height', topbarOffset);
                $topbar.addClass('top-bar-scrolled');
                setTimeout(function () {
                    $topbar.addClass('scrolled-out');
                }, 1);
            }
        } else {
            if ($topbar.hasClass('top-bar-scrolled')) {
                $topbar.removeClass('top-bar-scrolled scrolled-out');
                $topbarWrap.css('height', 'auto');
            }
        }

        if (topoffset > (topbarOffset + triggerOffset)) {
            if (!$topbar.hasClass('scrolled-in')) {
                $topbar.addClass('scrolled-in');
            }
        } else {
            if ($topbar.hasClass('scrolled-in')) {
                $topbar.removeClass('scrolled-in');
            }
        }
    });


    // initialize lightbox
    $('a.lightbox').nivoLightbox();


    // toggle searchbar
    $('#toggle-search').click(function (e) {
        e.preventDefault();
        $(this).closest('.search').addClass('show-input').find('.search-field').focus();
        $(this).hide();
    });
    $('.search .search-field').blur(function () {
        var $field = $(this);
        setTimeout(function () {
            $field.closest('.search').removeClass('show-input').find('#toggle-search').show();
        }, 2000);
    });


    // insert sub-menu-toggles in primary nav in nav-bar
    $('.nav-bar .nav-primary .menu > .menu-item-has-children').each(function () {
        $(this).append('<span class="sub-menu-toggle"><i class="far fa-plus"></i></span>');
    });

    $('.sub-menu-toggle').click(function () {
        var $parent = $(this).closest('.menu-item-has-children');
        var $submenu = $parent.find('.sub-menu');

        // collapse other shown sub-menu's when new sub-menu is toggled
        $parent.siblings().each(function () {
            if ($(this).hasClass('sub-menu-toggled')) {
                $(this).removeClass('sub-menu-toggled');
                $(this).find('.sub-menu').stop().slideUp(300, 'easeInOutCubic');
                $(this).find('.sub-menu-toggle').html('<i class="far fa-plus"></i>');
            }
        });

        // show/hide sub-menu
        if ($parent.hasClass('sub-menu-toggled')) {
            $parent.removeClass('sub-menu-toggled');
            $submenu.stop().slideUp(300, 'easeInOutCubic');
            $(this).html('<i class="far fa-plus"></i>');
        } else {
            $parent.addClass('sub-menu-toggled');
            $submenu.stop().slideDown(300, 'easeInOutCubic');
            $(this).html('<i class="far fa-minus"></i>');
        }
    });


    // review slider
    if ($('.review-slider').length) {
        $('.review-slider').slick({
            rows: 0,
            dots: false,
            arrows: true,
            prevArrow: '<span class="slider-arrow arrow-prev"><i class="fa fa-angle-left"></i></span>',
            nextArrow: '<span class="slider-arrow arrow-next"><i class="fa fa-angle-right"></i></span>',
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 250,
            easing: 'easeInOutCubic',
            centerMode: true,
            centerPadding: '10%',
            responsive: [{
                breakpoint: 1400,
                settings: {
                    centerPadding: '5%'
                }
            }, {
                breakpoint: 1200,
                settings: {
                    centerPadding: '50px'
                }
            }, {
                breakpoint: 400,
                settings: {
                    centerMode: false
                }
            }]
        });
    }

    // room slider
    if ($('.room-img-slider').length) {
        $('.room-img-slider .slide-wrapper').slick({
            rows: 0,
            arrows: true,
            prevArrow: '<button type="button" class="slidercontrol slider_prev"><div class="slidercontrol__icon"><i class="far fa-angle-left"></i></div></button>',
            nextArrow: '<button type="button" class="slidercontrol slider_next"><div class="slidercontrol__icon"><i class="far fa-angle-right"></i></div></button>',
            dots: false,
            infinite: true,
            autoplay: false,
            speed: 500,
            cssEase: 'ease',
        });
    }


    // input number controls (used in booking form)
    // set disabled classes when value equals min or max value on pageload
    $('.input-number-controls-wrapper .input-number-controls').each(function () {
        var $target = $(this).find('.number-input');
        var startVal = $target.val();
        var min = $target.data('min');
        var max = $target.data('max');

        if (startVal == min) {
            $(this).find('.button-minus').addClass('button-disabled');
        }
        if (startVal == max) {
            $(this).find('.button-plus').addClass('button-disabled');
        }
    });

    // set fake values when input values are bigger than 0
    $('.input-number-controls-wrapper .input-number-controls .number-input.update-fake-input').each(function () {
        var val = $(this).val();
        var targetID = $(this).data('fake-target-id');
        var $target = $('#' + targetID);
        if ($target.length) {
            var updateType = $(this).data('fake-target-update-type');
            var textSingle = $target.data('text-' + updateType + '-single');
            var textMultiple = $target.data('text-' + updateType + '-multiple');
            var $targetCount = $target.find('.' + updateType + '-input .' + updateType + '-count');
            var $targetString = $target.find('.' + updateType + '-input .' + updateType + '-string');

            if (val > 0) {
                $target.find('.' + updateType + '-input').show();
                $targetCount.html(val);
                if (val == 1) {
                    $targetString.html(textSingle);
                } else {
                    $targetString.html(textMultiple);
                }
            } else {
                $target.find('.' + updateType + '-input').hide();
            }
        }
    });

    // button click actions
    $('.input-number-controls-wrapper .input-number-controls .number-control-button').click(function (e) {
        e.preventDefault();
        var $target = $(this).siblings('.number-input');
        var min = $target.data('min');
        var max = $target.data('max');
        var currentVal = $target.val();
        var newVal = currentVal;

        if ($(this).hasClass('button-minus')) {
            if ($(this).siblings('.button-plus').hasClass('button-disabled')) {
                $(this).siblings('.button-plus').removeClass('button-disabled');
            }
            if (currentVal > min) {
                newVal--;
                $target.val(newVal).change();
                if (newVal == min) {
                    $(this).addClass('button-disabled');
                }
            } else {
                var errorText = $(this).data('error-text');
                // alert(errorText);
                if (!$(this).hasClass('button-disabled')) {
                    $(this).addClass('button-disabled');
                }
            }
        } else if ($(this).hasClass('button-plus')) {
            if ($(this).siblings('.button-minus').hasClass('button-disabled')) {
                $(this).siblings('.button-minus').removeClass('button-disabled');
            }
            if (currentVal < max) {
                newVal++;
                $target.val(newVal).change();
                if (newVal == max) {
                    $(this).addClass('button-disabled');
                }
            } else {
                var errorText = $(this).data('error-text');
                // alert(errorText);
                if (!$(this).hasClass('button-disabled')) {
                    $(this).addClass('button-disabled');
                }
            }
        }
    });

    // update fake input
    $('.input-number-controls-wrapper .input-number-controls .number-input.update-fake-input').change(function () {
        var newVal = $(this).val();
        var targetID = $(this).data('fake-target-id');
        var $target = $('#' + targetID);
        if ($target.length) {
            var updateType = $(this).data('fake-target-update-type');
            var textSingle = $target.data('text-' + updateType + '-single');
            var textMultiple = $target.data('text-' + updateType + '-multiple');
            var $targetCount = $target.find('.' + updateType + '-input .' + updateType + '-count');
            var $targetString = $target.find('.' + updateType + '-input .' + updateType + '-string');

            if (newVal > 0) {
                $target.find('.' + updateType + '-input').show();
                $targetCount.html(newVal);
                if (newVal == 1) {
                    $targetString.html(textSingle);
                } else {
                    $targetString.html(textMultiple);
                }
            } else {
                $target.find('.' + updateType + '-input').hide();
            }
        }
    });


    // booking form popup toggles
    $('.toggle-field-popup').click(function (e) {
        e.preventDefault();

        var $this = $(this);
        var $popup = $this.closest('.field-wrapper.field-has-popup').find('.field-popup');

        var position = this.getBoundingClientRect();
        var spaceBelow = window.innerHeight - position.bottom;
        var spaceAbove = position.top;

        if ($this.hasClass('popup-visible')) {
            $this.removeClass('popup-visible');

            $popup.stop().fadeOut(150, 'easeInOutCubic', () => {
                $popup.removeClass('field-popup--popup-bottom');
                $popup.removeClass('field-popup--popup-top');
            });
        } else {
            // close all other currently open popups
            $('.toggle-field-popup.popup-visible').each(function () {
                $this.removeClass('popup-visible');

                $this.closest('.field-wrapper.field-has-popup').find('.field-popup').stop().fadeOut(150, 'easeInOutCubic', () => {
                    $('.field-popup').removeClass('field-popup--popup-bottom');
                    $('.field-popup').removeClass('field-popup--popup-top');
                });
            });

            $this.addClass('popup-visible');

            // dont move popup to top in top booking bar
            if ($popup.closest('section.booking-bar').prev('.hero').length > 0) {
                $popup.addClass('field-popup--popup-bottom');
            } else {
                if (spaceBelow < $popup.height() && spaceAbove > $popup.height()) {
                    $popup.addClass('field-popup--popup-top');
                } else {
                    $popup.addClass('field-popup--popup-bottom');
                }
            }

            $popup.stop().fadeIn(150, 'easeInOutCubic');
        }
    });


    // hide certain elements when clicked outside them
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.field-wrapper.field-has-popup').length) {
            $('.toggle-field-popup').each(function () {
                if ($(this).hasClass('popup-visible')) {
                    $(this).removeClass('popup-visible');
                    $(this).closest('.field-wrapper.field-has-popup').find('.field-popup').stop().fadeOut(150, 'easeInOutCubic');
                }
            });
        }
        if (!$(e.target).closest('.nav-bar').length && $(e.target).attr('id') !== 'toggle-nav-bar') {
            if ($body.hasClass('show-nav-bar')) {
                $body.removeClass('show-nav-bar');
            }
        }
        if (!$(e.target).closest('.lang').length) {
            if ($('.lang').hasClass('lang--expanded')) {
                $('.lang').removeClass('lang--expanded');
            }
        }
    });


    // animated theme background on hover
    $('.animate-on-hover').hover(function () {
        if ($(this).find('.animated-bg').length) {
            var $animBg = $(this).find('.animated-bg');
            var animImg = $animBg.data('gif-src');
            $animBg.css({
                'background-image': 'url(' + animImg + '?' + Math.random() + ')' // the random number is added to force GIF playing from the start (reloading source) - not ideal for bandwidth with larger GIFs..
            });
        }
    }, function () {
        if ($(this).find('.animated-bg').length) {
            $(this).find('.animated-bg').stop().fadeOut(300, 'easeInOutCubic', function () {
                $(this).css({
                    'background-image': 'none'
                }).show();
            });
        }
    });


    // when a link is clicked with href attribute starting with #, scroll that shit smoothly (if target exists)
    $('a[href^="#"]').click(function (e) {
        e.preventDefault();
        var $anchor = $(this);
        var target = $(this).attr('href');

        if ($(target).length > 0) {
            $('html, body').stop().animate({
                scrollTop: $(target).offset().top - topbarOffset + 1
            }, 1000, 'easeInOutCubic', function () {
                $anchor.blur();
            });
        }
    });


    // pagenav mobile
    if ($('.page-nav-wrapper').length) {
        var $pageNavWrapper = $('.page-nav-wrapper');
        var $pageNavMenu = $pageNavWrapper.find('.page-nav-menu');

        // initialize scrollspy
        $body.scrollspy({
            target: '.page-nav-wrapper',
            offset: topbarOffset
        });


        function centerActiveItem() {
            var $activeItem = $('.page-nav-wrapper .page-nav-menu li.active');

            if (!$activeItem.length) {
                $activeItem = $('.page-nav-wrapper .page-nav-menu li').first();
            }

            var wrapperWidth = $('.page-nav-wrapper .page-nav').outerWidth();
            var menuWidth = 0;

            $('.page-nav-wrapper .page-nav-menu li').each(function () {
                menuWidth += $(this).outerWidth();
            });


            var prevWidth = 0;

            $activeItem.prevAll().each(function () {
                prevWidth += $(this).outerWidth();
            });

            var menuOffset = (wrapperWidth / 2) - ($activeItem.outerWidth() / 2) - prevWidth - 30;

            // cap menuoffset
            if (menuOffset > 0) {
                menuOffset = 0;
            }

            $('.page-nav-wrapper .page-nav-menu').css({
                'left': menuOffset
            });

        }

        function updatePageNav() {
            var $menu = $('.page-nav-wrapper .page-nav-menu');
            var $itemActive = $menu.find('li.active');
            var $controlPrev = $('.page-nav-wrapper .page-nav-control.control-prev');
            var $controlNext = $('.page-nav-wrapper .page-nav-control.control-next');

            if ($itemActive.index() == 0) {
                $controlPrev.addClass('control-disabled');
            } else {
                $controlPrev.removeClass('control-disabled');
            }

            if ($itemActive.index() == $menu.find('li').length - 1) {
                $controlNext.addClass('control-disabled');
            } else {
                $controlNext.removeClass('control-disabled');
            }

            centerActiveItem();
        }

        $('.page-nav-wrapper').on('activate.bs.scrollspy', function () {
            updatePageNav();
        });

        // behavior for page-nav-controls
        $('.page-nav-wrapper .page-nav-control').click(function (e) {
            e.preventDefault();

            if (!$(this).hasClass('control-disabled')) {
                var $menu = $(this).closest('.page-nav-wrapper').find('.page-nav-menu');
                var $itemActive = $menu.find('li.active');

                if ($(this).hasClass('control-prev')) {
                    // if not first item
                    if ($itemActive.index() !== 0) {
                        $itemActive.prev().find('a').trigger('click');
                    }
                } else if ($(this).hasClass('control-next')) {
                    // if not last item
                    if ($itemActive.index() !== $menu.find('li').length - 1) {
                        $itemActive.next().find('a').trigger('click');
                    }
                }
            }
        });

        updatePageNav();
    }


    // toggle 360 view
    $('#toggle-360').on('click', function (e) {
        e.preventDefault();

        var $hero = $('section.hero'),
            $hero360 = $hero.find('.hero-background-360'),
            class360Visible = 'hero--show-360';

        $hero360.show();
        $hero.addClass(class360Visible);
    });


    // setting iframe height aspect ratio 16:9 when it contains a youtube video
    $('.contentwrapper iframe').each(function () {
        var $url = $(this).attr('src');
        if ($url.indexOf('youtube.com') >= 0 || $url.indexOf('youtu.be') >= 0) {
            iframeSetAspectRatio($(this));
        }
    });


    // on window resize events
    $(window).on('resize', function () {
        // re-setting iframe height aspect ratio 16:9 when it contains a youtube video
        $('.contentwrapper iframe').each(function () {
            var $url = $(this).attr('src');
            if ($url.indexOf('youtube.com') >= 0 || $url.indexOf('youtu.be') >= 0) {
                iframeSetAspectRatio($(this));
            }
        });

    });


    // load more results
    $('.load-more-results #load-more').click(function (e) {
        e.preventDefault();
        if (!$(this).hasClass('btn-disabled')) {
            $(this).removeClass('btn-default btn-primary').addClass('btn-disabled');
            $('<i/>', {
                'class': 'fa fa-right fa-circle-o-notch fa-spin',
            }).appendTo('.load-more-results #load-more');
        }
    });


    // auto submit form
    $('form.auto-submit').change(function () {
        $('.loader-overlay').stop().fadeIn(150, 'easeInOutCubic');
        this.submit();
    });


    // filter toggles
    $('.filter .toggle-collapse-filter').click(function (e) {
        e.preventDefault();
        var $filter = $(this).closest('.filter');
        if ($filter.hasClass('filter-collapsed')) {
            $filter.removeClass('filter-collapsed').find('.filter-collapsable').slideDown(150, 'easeInOutCubic');
        } else {
            $filter.addClass('filter-collapsed').find('.filter-collapsable').slideUp(150, 'easeInOutCubic');
        }
    });
    // on page-load collapse all filters on mobile, on desktop only collapse filter with class .filter-collapsed
    if ($(window).width() > 991) {
        $('.filter.filter-collapsed').each(function () {
            $(this).find('.filter-collapsable').slideUp(150, 'easeInOutCubic');
        });
    } else {
        $('.filter').each(function () {
            $(this).addClass('filter-collapsed').find('.filter-collapsable').slideUp(150, 'easeInOutCubic');
        });
    }


    //language selector
    $('select[name="lang"]').change(function () {
        window.location.href = $(this).find('option:selected').val();
    });

    // adding readonly attributes to certain GF fields
    if ($('.gform_wrapper li.wc_readonly').length) {
        $('.gform_wrapper li.wc_readonly').each(function () {
            // for inputs
            $(this).find('input').attr('readonly', 'readonly');
            // for textarea
            $(this).find('textarea').attr('readonly', 'readonly');
        });
    }

    $('.content-expandable').each(function () {
        var $container = $(this);

        var $toggles = $container.find('.expand, .collapse');
        $toggles.click(function () {
            $container.toggleClass('expanded')
        });


    });


    /*
    if ($('.location-map').length) {
       $maps = $('.location-map').maps({
            scrollwheel: false,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            mapTypeId: google.maps.MapTypeId.TERRAIN,
            styles: [{
                stylers: [{
                    saturation: -50
                }]
            }]
        });

       $maps.map.panBy(0, -100);
    }*/


    if ($('.popover-language-select').length) {
        var selectedLanguage = Cookies.get('lang');

        if (!selectedLanguage) {
            $('#open-lang-popover').trigger('click');
        }
    }

    // social share pop-ups
    function windowPopup(url, width, height) {
        // Calculate the position of the popup so
        // it’s centered on the screen.
        var left = (screen.width / 2) - (width / 2),
            top = (screen.height / 3) - (height / 2);

        window.open(
            url,
            "",
            "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left
        );
    }

    // jQuery
    $(".dbk-social-share").on("click", function (e) {
        e.preventDefault();
        windowPopup($(this).attr("href"), 500, 300);
    });

    // disable hero-video with URL variable
    if (window.location.search.indexOf('no_video=1') >= 0) {
        $('section.hero .hero-background-video').remove();
    }


    // toggle map pins on hotel-map
    $('.hotel-map__pin').on('mouseenter click', function () {
        let $map = $(this).closest('.hotel-map'),
            $pin = $(this),
            classPin = 'hotel-map__pin',
            classPinToggled = 'hotel-map__pin--toggled';

        $pin.addClass(classPinToggled);
        $map.find('.' + classPin).not($pin).removeClass(classPinToggled);
    });


    // hero image slider
    $('.hero-background-image-slider').slick({
        rows: 0,
        arrows: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        fade: true
    });


    // quotes slider
    $('.quotes-slider').slick({
        rows: 0,
        arrows: true,
        dots: true,
        prevArrow: '<a href="#" class="slick-control slick-control--prev gtm-event" title="Vorige" data-gtm-event="Quotes slider control: previous" rel="nofollow"><i class="far fa-angle-left"></i></a>',
        nextArrow: '<a href="#" class="slick-control slick-control--next gtm-event" title="Volgende" data-gtm-event="Quotes slider control: next" rel="nofollow"><i class="far fa-angle-right"></i></a>',
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        lazyLoad: 'ondemand',
        adaptiveHeight: true,
        customPaging: function (slick, index) {
            return '<a id="slick-dot-' + index + '" class="slick-dot" rel="nofollow"><span class="slick-dot__inner"></span></a>';
        },
        responsive: [
            {
                breakpoint: 1201,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 676,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    }).on('click', '.slick-slide', function (e) {
        // moving slider when item that is not active is clicked
        if (!$(this).hasClass('slick-active')) {
            e.preventDefault();

            let $slider = $(this).closest('.slick-slider');

            // check if slide is before or after active slides
            if ($(this).prevAll('.slick-active').length) {
                // console.log('element comes after active');
                $slider.slick('slickNext');
            } else {
                // console.log('element comes before active');
                $slider.slick('slickPrev');
            }
        }
    });


    // expandable items
    $('.expandable-items .item .item__toggle').on('click', function (e) {
        e.preventDefault();

        let $toggle = $(this),
            $item = $toggle.closest('.item'),
            toggledClass = 'item--toggled',
            $content = $toggle.siblings('.item__content');

        if ($item.hasClass(toggledClass)) {
            $item.removeClass(toggledClass);
            $content.stop().slideUp(150, 'easeInOutCubic');
        } else {
            $item.addClass(toggledClass);
            $content.stop().slideDown(150, 'easeInOutCubic');
        }
    });

    // expand pre-toggled expandable items on pageload
    $('.expandable-items .item.item--toggled').each(function () {
        let $content = $(this).find('.item__content');

        $content.stop().slideDown(150, 'easeInOutCubic');
    });


    // copy page url to clipboard
    $('.social-share__link--url').on('click', function () {
        let $link = $(this),
            classShowTooltip = 'social-share__link--show-tooltip',
            currentUrl = window.location.href;

        copyToClipboard(currentUrl);

        if (!$link.hasClass(classShowTooltip)) {
            $link.addClass(classShowTooltip);

            setTimeout(function () {
                $link.removeClass(classShowTooltip);
            }, 1000);
        }
    });

    function copyToClipboard(string) {
        // for reference: https://stackoverflow.com/questions/34045777/copy-to-clipboard-using-javascript-in-ios

        let dummyInput,
            result;

        try {
            dummyInput = document.createElement('input');
            dummyInput.setAttribute('readonly', true);
            dummyInput.setAttribute('contenteditable', true);
            dummyInput.style.position = 'fixed'; // prevent jumping to bottom (iOS)
            dummyInput.style.top = 50 + '%'; // prevent jumping to bottom (iOS)
            dummyInput.value = string;

            document.body.appendChild(dummyInput);

            dummyInput.focus();
            dummyInput.select();

            const range = document.createRange();
            range.selectNodeContents(dummyInput);

            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);

            dummyInput.setSelectionRange(0, dummyInput.value.length);
            result = document.execCommand('copy');
        } catch (err) {
            console.error(err);
            result = null;
        } finally {
            document.body.removeChild(dummyInput);
        }
    }


    // init tooltips
    $body.tooltip({
        trigger: 'click',
        selector: '[data-toggle="feature-tooltip"]',
        container: 'body'
    }).on('show.bs.tooltip', () => {
        $('.tooltip').not(this).hide();
    });

    $('html').tooltip({ // if $body is used again it doesn't work
        selector: '[data-toggle="tooltip"]',
        container: 'body'
    });


    // quotes slider
    $('.events__slider').slick({
        rows: 0,
        arrows: true,
        dots: false,
        prevArrow: '<a href="#" class="slick-control slick-control--prev gtm-event" title="Vorige" data-gtm-event="Events slider control: previous" rel="nofollow"><i class="far fa-angle-left"></i></a>',
        nextArrow: '<a href="#" class="slick-control slick-control--next gtm-event" title="Volgende" data-gtm-event="Events slider control: next" rel="nofollow"><i class="far fa-angle-right"></i></a>',
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        infinite: false,
        speed: 500,
        lazyLoad: 'ondemand',
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1201,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 676,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    }).on('click', '.slick-slide', function (e) {
        // moving slider when item that is not active is clicked
        if (!$(this).hasClass('slick-active')) {
            e.preventDefault();

            let $slider = $(this).closest('.slick-slider');

            // check if slide is before or after active slides
            if ($(this).prevAll('.slick-active').length) {
                // console.log('element comes after active');
                $slider.slick('slickNext');
            } else {
                // console.log('element comes before active');
                $slider.slick('slickPrev');
            }
        }
    });


    $('.hotels-wrapper .hotel').hover(function () {
        let $video = $('.hotel__video', this).get(0);
        if ($video) {
            $video.play();
        }
    }, function () {

        let $video = $('.hotel__video', this).get(0);

        if ($video) {
            $video.pause();
            setTimeout(function () {
                $video.load();
            }, 150);
        }
    });


    $('[data-action="open-booking"]').on('click', function (e) {
        e.preventDefault();

        $('.booking-bar [type="submit"]').trigger('click');
    });


    $('[data-action="scroll-to-nearest-booking-form"]').on('click', function (e) {
        e.preventDefault();

        var $scrollTarget = $('.booking-bar').first();

        if ($scrollTarget.length > 0) {
            $('html, body').stop().animate({
                scrollTop: $scrollTarget.offset().top - topbarOffset + 1
            }, 1000, 'easeInOutCubic');
        }

        $(this).blur();
    });


    if ($('.scroll-load-container').length > 0) {
        var infScroll = new InfiniteScroll('.scroll-load-container', {
            path: '.next.page-numbers',
            append: '.post-list-item',
            prefill: false,
            history: false,
            hideNav: '.pagination',
            status: '.page-load-status',
        });
    }


    function updateFakeInputValue() {
        $('input[type="radio"].update-fake-input, input[type="checkbox"].update-fake-input').each(function () {

            var $input = $(this),
                targetID = $input.data('fake-target-id');

            if (typeof targetID !== 'undefined' && targetID !== '') {
                var $target = $('#' + targetID);

                if ($target.length > 0) {
                    var $checked = $('input[name="' + $input.attr('name') + '"]:checked');

                    if ($checked.length > 0) {
                        var displayValue = $checked.data('display-value');

                        if (typeof displayValue === 'undefined' || displayValue === '') {
                            displayValue = $checked.val();
                        }

                        $target.html(displayValue);
                    }

                    $input.on('change', function () {
                        var displayValue = $input.data('display-value');

                        if (typeof displayValue === 'undefined' || displayValue === '') {
                            displayValue = $input.val();
                        }

                        $target.html(displayValue);

                        // if input is inside field-popup, close on select
                        var $popup = $input.closest('.field-popup');

                        if ($popup.length > 0) {
                            $popup.closest('.field-wrapper.field-has-popup').find('.toggle-field-popup').removeClass('popup-visible');
                            $popup.stop().fadeOut(150, 'easeInOutCubic');
                        }
                    });
                }
            }
        });
    }
    updateFakeInputValue();


    // toggle header lang dropdown
    $('#toggle-language-dropdown').on('click', function () {
        var $lang = $(this).closest('.lang'),
            classLangExpanded = 'lang--expanded';

        if ($lang.hasClass(classLangExpanded)) {
            $lang.removeClass(classLangExpanded);
        } else {
            $lang.addClass(classLangExpanded);
        }
    });
    $('.lang .lang__option:not(.lang__option--active)').on('click', function () {
        $(this).closest('.lang').removeClass('lang--expanded');
    });


    // insert dropdown icons to woocommerce select elements
    $('.woocommerce .woocommerce-ordering').each(function () {
        $(this).append('<div class="field_icon"><i class="fas fa-sort"></i></div>');
    });
    $('.woocommerce table.variations select').each(function () {
        $(this).wrap('<div class="input-wrapper"></div>');
        $(this).parent().append('<div class="field_icon"><i class="fas fa-sort"></i></div>');
    });


    $('p').each(function () { // filter out empty paragraphs
        let $paragraph = $(this);

        if ('&nbsp;' === $paragraph.html()) {
            $paragraph.remove();
        }
    });


    // load extra JS parts
    require('./mews');
    require('./synxis');
    require('./pikaday.js');
    require('./weather.js');
    require('./pressroom');
    require('./modals');
    require('./gravity-forms.js');
    require('./scroll-to-top.js');
    require('./booking.js');
    require('./mega-menu.js');
    require('./footer.js');
    require('./dbk-gallery.js');
    require('./room-tabs.js');

};
